import api from './api';
import type { Paginated, Vehicle } from '../types/api';

export async function listVehicles(params?: Record<string, string | number>) {
  const { data } = await api.get<Paginated<Vehicle> | Vehicle[]>('/vehicles/', { params });
  return Array.isArray(data) ? data : data.results;
}

export async function createVehicle(payload: Partial<Vehicle>) {
  const { data } = await api.post<Vehicle>('/vehicles/', payload);
  return data;
}

export async function updateVehicle(id: number, payload: Partial<Vehicle>) {
  const { data } = await api.patch<Vehicle>(`/vehicles/${id}/`, payload);
  return data;
}

export async function toggleActive(id: number, isActive: boolean) {
  const { data } = await api.patch<Vehicle>(`/vehicles/${id}/`, { is_active: !isActive });
  return data;
}

export async function deleteVehicle(id: number) {
  await api.delete(`/vehicles/${id}/`);
}
